import { Button as MuiButton, useTheme } from '@mui/material';
import React from 'react'

const Button = (props) => {

    const theme = useTheme();
    const {children, color, variant, onClick, className, size, disabled, sx, ...other} = props;

    return (
        <MuiButton
            className={className || ''}
            disabled={disabled}
            size={size}
            sx={{textTransform:'none', margin:theme.spacing(1), ...sx}}
            variant={variant || 'contained'}
            color={color}
            onClick={onClick}
            {...other} >
            {children}
        </MuiButton>
    )
}

export default Button